import t from '../translations'
import { readStorage } from '../storage'
import { requireTextAnswersIfMarkIsLowerThanX } from '../options'

// Reguły walidacji ankiety są takie jak od 2020 r.; zmienia się tylko to, jak wynik trafia do kursanta:
// 1) pytania RANGE i NPS wymagają odpowiedzi;
// 2) ocena RANGE poniżej progu (poza „Nie było mnie na zajęciach”) wymaga co najmniej jednej niepustej odpowiedzi
//    tekstowej przy tym samym prowadzącym; pytania ogólne (bez prowadzącego) sprawdzane są razem. NPS bez tej reguły.

export const isRequiredQuestion = (question) => question.type === 'RANGE' || question.type === 'NPS'

// Próg niskiej oceny: z options.js, w testach Cypressa nadpisywany kluczem w localStorage (jak od 2020 r.).
// Wspólny dla walidacji (saveAnswers) i przycisku „OK” (okButton).
export const lowMarkThreshold = () => Number(
  readStorage('__requireTextAnswersIfMarkIsLowerThanX__') ||
  requireTextAnswersIfMarkIsLowerThanX
)

const isFilledText = (answer) => answer !== undefined && answer.trim() !== ''

const hasNoTextAnswer = (group, answers) => group.textQuestionIds.every(questionId => !isFilledText(answers[questionId]))

export const findMissingQuestionIds = (questions, answers) => questions
  .filter(isRequiredQuestion)
  .filter(question => answers[question.questionId] === undefined)
  .map(question => question.questionId)

// Prowadzący (albo pytania ogólne: trainer undefined/null) z oceną RANGE poniżej progu — każdy raz, w kolejności
// pytań. Jedno wykrywanie niskiej oceny dla walidacji i dla przycisku „OK”.
export const findLowMarkTrainerIds = (questions, answers, threshold) => questions
  .filter(question => question.type === 'RANGE')
  .filter(question => (
    answers[question.questionId] !== 'not-present' &&
    Number(answers[question.questionId]) < threshold
  ))
  .map(question => question.trainer)
  .filter((trainerId, index, all) => all.indexOf(trainerId) === index)

// Grupy (prowadzący albo pytania ogólne) z niską oceną i bez żadnej odpowiedzi tekstowej — każda raz,
// w kolejności pytań. Wcześniej nazwisko powtarzało się przy każdej niskiej ocenie.
export const findLowMarkGroups = (questions, answers, threshold) => findLowMarkTrainerIds(questions, answers, threshold)
  .map(trainerId => ({
    trainerId,
    textQuestionIds: questions
      .filter(question => question.trainer === trainerId && question.type === 'TEXT')
      .map(question => question.questionId),
  }))
  // bez pytań tekstowych przy prowadzącym nie ma czego wymagać (jak dotąd)
  .filter(group => group.textQuestionIds.length > 0)
  .filter(group => hasNoTextAnswer(group, answers))

// Błędy widoczne na ekranie: z ostatniej próby wysłania i tylko dopóki problem trwa —
// zaznaczenie odpowiedzi albo wpisanie uzasadnienia od razu chowa komunikat.
export const visibleMissingQuestionIds = (validation, answers) => (
  validation ?
    validation.missingQuestionIds.filter(questionId => answers[questionId] === undefined)
    :
    []
)

export const visibleLowMarkGroups = (validation, answers) => (
  validation ?
    validation.lowMarkGroups.filter(group => hasNoTextAnswer(group, answers))
    :
    []
)

// Nazwa grupy w komunikacie: imię i nazwisko, „pytania ogólne” zamiast pustej pozycji, a gdy dane prowadzącego
// się nie wczytały — temat sekcji (ten sam co w jej nagłówku).
export const lowMarkGroupLabel = (group, questions, trainersData) => {
  if (group.trainerId === undefined || group.trainerId === null) return t.pollView.generalQuestions

  const trainer = (trainersData || []).find(trainer => trainer.trainerUid === group.trainerId)
  if (trainer) return `${trainer.firstName} ${trainer.lastName}`

  const questionWithSubject = questions.find(question => question.trainer === group.trainerId && question.subject)
  return questionWithSubject ? questionWithSubject.subject : t.pollView.unknownTrainer
}
